import { db, StoryEntity } from '@/shared/lib/db'
import { toastService } from '@/shared/services/toast.service'
import { LexicalEditor } from 'lexical'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface StoryState {
    storyEntity: StoryEntity | undefined
    editor: LexicalEditor | null,
    isLoading: boolean,
    setEditor: (editor: LexicalEditor) => void,
    loadStory: (projectId: string) => Promise<void>
}

export const useStoryStore = create<StoryState>()(
    devtools((set) => ({
        storyEntity: undefined,
        editor: null,
        setEditor: (editor) => {
            set({ editor: editor })
        },
        loadStory: async (projectId) => {
            set({ isLoading: true })
            try {
                // Fetch the first screenplay for the project
                const storyEntity = await db.stories
                    .where('projectId')
                    .equals(projectId)
                    .first()

                if (storyEntity && storyEntity.content) {
                    set({ storyEntity, isLoading: false })
                } else {
                    set({ storyEntity: undefined, isLoading: false })
                }
            } catch (error) {
                toastService.error('Failed to load story')
            } finally {
                set({ isLoading: false })
            }
        },
    }))
)
